import React from 'react'


const Service = ({imgName,flexType,bg,title,description}) => {
    const bgStyle = {
        backgroundImage: `url(${imgName})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      
      };
  return (
    <div className={`w-[100%] ${bg} `}>
        <div className={`w-[100%] ${bg} max-w-[1600px] flex ${flexType} mx-auto h-auto justify-center items-center`}>
        <div className=' w-[100%] md:w-[50%] flex flex-col justify-center items-center p-[50px] md:p-[100px] text-center'>
        <p className='text-[30px] md:text-[40px] font-semibold mb-[15px] font-poppins'>{title}</p>
        <p className='text-[15px] md:text-[16.5px] font-figtree'>{description}</p>
        </div>
        <div  className=' w-[100%] md:w-[50%] h-[300px] max-h-[300px] md:h-[400px] md:max-h-[400px]' style={bgStyle}>
            {/* <img src={Why1} className='w-[100%] h-[100%] object-contain'/> */}

        </div>
        </div>
      
      
    </div>
  )
}

export default Service








